import SubscriptionDetailsPage from 'components/souscriptions/subscriptionDetails/SubscriptionDetailsPage';

export default SubscriptionDetailsPage;
